/* eslint-disable */
import {
  Box,
  Button,
  Checkbox,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteReminder,
  getReminders,
} from '../../stores/slices/reminders/remindersActions';
import { filterByValue } from '../../utils/filterByValue';
import DeleteAlert from '../Alerts/DeleteAlert';
import ReminderModal from './ReminderModal';
import moment from 'moment';
import * as ics from 'ics';
import { isIOSSafari } from '../../utils/isIOSSafari';
import { downloadIcsBlob } from '../../utils/downloadIcsBlob';

const Reminder = () => {
  const { userInfo } = useSelector(state => state.user);
  const { reminders, loading } = useSelector(state => state.reminders);
  const [filteredReminders, setFilteredReminders] = useState([]);
  const [selectedReminders, setSelectedReminders] = useState([]);
  const [toUpdate, setToUpdate] = useState({ state: false, reminder: null });
  const [isDeleting, setIsDeleting] = useState(false);
  const cancelRef = useRef();
  const searchRef = useRef();
  const filterRef = useRef();
  const [reminderType, setReminderType] = useState('reminder');
  // const [isLoading, setIsLoading] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlertAlert,
    onClose: onCloseAlert,
  } = useDisclosure();
  const toast = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReminders());
  }, []);

  useEffect(() => {
    setFilteredReminders(reminders);
  }, [reminders]);

  const handleSelectAll = event => {
    let newSelectedReminders;

    if (event.target.checked) {
      newSelectedReminders = reminders.map(reminder => reminder.id);
    } else {
      newSelectedReminders = [];
    }

    setSelectedReminders(newSelectedReminders);
  };
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedReminders.indexOf(id);
    let newSelectedReminders = [];

    if (selectedIndex === -1) {
      newSelectedReminders = newSelectedReminders.concat(selectedReminders, id);
    } else if (selectedIndex === 0) {
      newSelectedReminders = newSelectedReminders.concat(
        selectedReminders.slice(1)
      );
    } else if (selectedIndex === selectedReminders.length - 1) {
      newSelectedReminders = newSelectedReminders.concat(
        selectedReminders.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedReminders = newSelectedReminders.concat(
        selectedReminders.slice(0, selectedIndex),
        selectedReminders.slice(selectedIndex + 1)
      );
    }

    setSelectedReminders(newSelectedReminders);
  };
  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, reminder: null });
  };

  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(deleteReminder({ selectedReminders }));
    await dispatch(getReminders());
    onCloseAlert();
    setIsDeleting(false);
    if (res.type === 'reminders/deleteReminder/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      setSelectedReminders([]);
      toast({
        description: 'Item has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };

  const filter = data => {
    const text = data.target.value;
    if (filterRef.current.value !== '') {
      setFilteredReminders(filterByValue(filteredReminders, text));
    } else {
      setFilteredReminders(filterByValue(reminders, text));
    }
  };

  const filterByType = data => {
    const type = data.target.value;
    const text = searchRef.current.value;
    if (type === '') {
      setFilteredReminders(filterByValue(reminders, text));
      return;
    }
    setFilteredReminders(
      filterByValue(
        reminders.filter(item => {
          if (type == 'reminder') {
            return (
              item.reminder_type === type ||
              item.reminder_type === '' ||
              item.reminder_type === null
            );
          }
          return item.reminder_type === type;
        }),
        text
      )
    );
  };

  const clearInput = () => {
    searchRef.current.value = '';
    filterRef.current.value = '';
    setFilteredReminders(reminders);
  };

  const generateRecurrence = (unit, num) => {
    const frequency = {
      days: 'DAILY',
      weeks: 'WEEKLY',
      months: 'MONTHLY',
    };
    return `FREQ=${frequency[unit]};INTERVAL=${num}`;
  };
  const downloadReminder = async reminder => {
    // setIsLoading(true);
    const dueDate = new Date(reminder.due);
    const dueTime = new Date(reminder.due_time);
    const { error, value } = ics.createEvent({
      start: [
        dueDate.getFullYear(),
        dueDate.getMonth() + 1,
        dueDate.getDate(),
        dueTime.getUTCHours(),
        dueTime.getUTCMinutes(),
      ],
      duration: { minutes: 30 },
      title: reminder.reminder,
      organizer: { name: userInfo.full_name, email: userInfo.email },
      attendees: reminder.users.map(user => {
        return {
          name: user.full_name,
          email: user.email,
        };
      }),
      ...(reminder.repeat_unit !== 'norepeat'
        ? {
            recurrenceRule: generateRecurrence(
              reminder.repeat_unit,
              reminder.repeat_num
            ),
          }
        : {}),
    });
    // setIsLoading(false);
    if (error) {
      console.log(error);
      return;
    }

    let url = value;
    if (isIOSSafari()) {
      url = encodeURI(`data:text/calendar;charset=utf8,${value}`);
      window.open(url, '_blank');
      return;
    }

    downloadIcsBlob(url, `${reminder.reminder}.ics`);
  };

  return (
    <React.Fragment>
      <Box w={'full'} overflowX={'hidden'} overflowY={'auto'}>
        <VStack spacing={'4'}>
          <Stack
            justifyContent={'space-between'}
            alignContent={'center'}
            direction={{ base: 'column', md: 'row' }}
            w={'full'}
            spacing={4}
            pr={'2'}
            pb={'2'}
            zIndex={'10'}
            sx={{
              position: '-webkit-sticky',
              /* Safari */
              position: 'sticky',
              top: '0',
            }}
            bg={'white'}
            borderBottom={'1px'}
            borderColor={'gray.500'}
          >
            <Flex
              flex={'1'}
              gap={'2'}
              direction={{ base: 'column', lg: 'row' }}
              maxW={{ base: '100%', md: '50%' }}
            >
              <Select
                id="filterType"
                size="sm"
                borderRadius={'4'}
                w={{ base: '100%', lg: '25%' }}
                defaultValue={''}
                ref={filterRef}
                onChange={filterByType}
              >
                <option value="">All</option>
                <option value="checkin">Check-ins</option>
                <option value="reminder">Reminders</option>
              </Select>
              <InputGroup size="sm" maxW={{ base: '100%', lg: '50%' }}>
                <Input
                  pr="4.5rem"
                  placeholder="Search"
                  borderRadius={'4'}
                  onChange={filter}
                  ref={searchRef}
                />
                <InputRightElement width="4.5rem" justifyContent={'end'}>
                  <Button
                    size={'sm'}
                    borderLeftRadius={'none'}
                    onClick={clearInput}
                  >
                    Clear
                  </Button>
                </InputRightElement>
              </InputGroup>
            </Flex>
            <HStack spacing={2}>
              {userInfo.role === 'employer' ||
              userInfo.role === 'manager' ||
              userInfo.role === 'coach' ? (
                <Button
                  size={'sm'}
                  onClick={() => {
                    setReminderType('checkin');
                    onOpen();
                  }}
                >
                  Add Check-In
                </Button>
              ) : null}
              <Button
                size={'sm'}
                onClick={() => {
                  setReminderType('reminder');
                  onOpen();
                }}
              >
                Add Reminder
              </Button>
              <Button
                size={'sm'}
                disabled={selectedReminders.length <= 0}
                bg={'red.400'}
                _hover={{
                  color: 'red.400',
                  bg: 'transparent',
                }}
                onClick={onOpenAlertAlert}
              >
                Delete
              </Button>
            </HStack>
          </Stack>
          <Box overflowX={'auto'} w={'full'}>
            <TableContainer>
              <Table
                variant="striped"
                colorScheme="gray"
                display={{
                  base: 'block',
                  md: 'table',
                }}
              >
                <Thead>
                  <Tr>
                    <Th>
                      <Checkbox
                        value="true"
                        onChange={handleSelectAll}
                        isChecked={
                          selectedReminders.length === reminders.length
                        }
                      />
                    </Th>
                    <Th>Due Date</Th>
                    <Th>Employee/s</Th>
                    <Th>Reminder</Th>
                    <Th>Type</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {reminders &&
                    (loading ? (
                      <Tr>
                        <Td colSpan={'5'}>
                          <Spinner color="primary" />
                        </Td>
                      </Tr>
                    ) : reminders.length > 0 ? (
                      filteredReminders.map(reminder => (
                        <Tr key={reminder.id}>
                          <Td>
                            <Checkbox
                              value="true"
                              isChecked={
                                selectedReminders.indexOf(reminder.id) !== -1
                              }
                              onChange={event =>
                                handleSelectOne(event, reminder.id)
                              }
                            />
                          </Td>
                          <Td>
                            {format(new Date(reminder.due), 'd MMM')}{' '}
                            {reminder.due_time &&
                              moment.utc(reminder.due_time).format('h:mm a')}
                          </Td>
                          <Td>
                            {reminder.users.map((user, index) => (
                              <span key={user.id}>
                                {user.full_name}
                                {reminder.users.length > 1 &&
                                index < reminder.users.length - 1
                                  ? ', '
                                  : ''}
                              </span>
                            ))}
                          </Td>
                          <Td>{reminder.reminder}</Td>
                          <Td textTransform={'capitalize'}>
                            {reminder.reminder_type || 'Reminder'}
                          </Td>
                          <Td align={'right'} textAlign={'right'}>
                            <HStack>
                              <Button
                                onClick={() => downloadReminder(reminder)}
                              >
                                Download
                              </Button>
                              <Button
                                onClick={() => {
                                  setToUpdate({
                                    state: true,
                                    reminder,
                                  });
                                  onOpen();
                                }}
                              >
                                Edit
                              </Button>
                            </HStack>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={'6'}>No files found</Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </VStack>
      </Box>
      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Delete Log${selectedReminders.length > 1 ? 's' : ''}`}
        body={
          "Are you sure? If you proceed with the deletion, it'll be gone forever."
        }
        onDeleteItem={onDeleteItem}
      />
      {isOpen && (
        <ReminderModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
          reminderType={reminderType}
        />
      )}
    </React.Fragment>
  );
};

export default Reminder;
